import { Component, OnInit, Inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-scan-qrcode',
  templateUrl: './scan-qrcode.component.html',
  styleUrls: ['./scan-qrcode.component.less']
})
export class ScanQrcodeComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    iconRegistry: MatIconRegistry
  ) {
    iconRegistry.addSvgIcon(
      'scan-qrcode',
      sanitizer.bypassSecurityTrustResourceUrl('assets/icons/scan-qrcode.svg')
    )
  }

  ngOnInit(): void {
  }

  runScan(): void {
    const dialogRef = this.dialog.open(ViewQRScan, {});
  }


}

@Component({
  selector: 'view-qr-scan',
  template: `
  <div style='display:flex;align-items:center;flex-direction:column'>
  <zxing-scanner [formats]="['QR_CODE']" (click)='onNoClick()' [device]='cam' (camerasFound)='gotCamera($event)' (scanSuccess)='afterSuccessScan($event)'></zxing-scanner>
  <button mat-button mat-icon-button *ngIf='cams.length>1' (click)="changeCam()">
      <mat-icon style="margin:auto">swap_horiz</mat-icon>
  </button>
  <div *ngIf='show_info'>Aby móc zeskanować kod qr niezbędny jest dostęp do kamery twojego urządzania.</div>
  </div>
  `
})
export class ViewQRScan {

  cam: any = null;
  cams: any[] = [null];
  cam_idx: number = 0;
  show_info = true;

  constructor(
    public dialogRef: MatDialogRef<ViewQRScan>,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close()
  }

  async afterSuccessScan(e): Promise<void> {
    // let addr = e.split('/');
    const url = new URL(e);
    if (url.host === location.host) {
      await this.router.navigate([url.pathname]);
      this.dialogRef.close();
    } else {
      this.dialogRef.close();
      window.alert('wrong hostname')
    }
  }

  gotCamera(e: any[]): void {
    this.show_info = false;
    this.cams = e.filter((c, i, cs) => cs.findIndex(e => e.deviceId === c.deviceId) === i);
    this.cam_idx = e.length - 1;
    this.cam = this.cams[this.cam_idx];
  }

  changeCam(): void {
    this.cam_idx = (this.cam_idx + 1) % this.cams.length
    this.cam = this.cams[this.cam_idx]
  }

}
